import { CountryCode } from "libphonenumber-js";
import { ClientFilterPageRequest } from "../modules/client/types";
import { ContractFilterPageRequest } from "../modules/contract/types";
import { CountryTwoLetterCode } from "./enums";

export const ATTACHMENT_BOUNDARY_PATH_PREFIX = "/file-view";
export const WILDCARD_ROUTE = "*";
export const NESTED_ROUTE_PATH = "/" + WILDCARD_ROUTE;
export const AUTH_REDIRECT_SEARCH_PARAM = "redirect";

export const ACCESS_TREE_PATH_DELIMITER = "|";
export const rowGutter = 16;

export const ViewBreakpoints = {
  TABLET: 992,
  DESKTOP: 1280,
  DESKTOP_XXL: 1600,
  DESKTOP_XXXL: 1920,
};

export const PageSizes = {
  TINY: 5,
  SMALL: 10,
  MEDIUM: 15,
  LARGE: 25,
  HUGE: 50,
};

export const ModalSizes = {
  TINY: 400,
  SMALL: 500,
  MEDIUM: 700,
  LARGE: 850,
  HUGE: 1000,
  XXL: 1300,
};

export const DrawerSizes = {
  SMALL: 500,
  MEDIUM: 800,
  LARGE: 975,
  HUGE: 1300,
};

export const TableSizes = {
  SMALL: 600,
  MEDIUM: 900,
  LARGE: 1150,
  HUGE: 1500,
  XXL: 1950,
};

export const Cities = [
  "Bratislava",
  "Košice",
  "Banská Bystrica",
  "Nitra",
  "Prešov",
  "Trenčín",
  "Trnava",
  "Žilina",
  "Banská Štiavnica",
  "Bardejov",
  "Brezno",
  "Bytča",
  "Bánovce nad Bebravou",
  "Detva",
  "Dolný Kubín",
  "Dunajská Streda",
  "Galanta",
  "Gelnica",
  "Hlohovec",
  "Humenné",
  "Iľava",
  "Kežmarok",
  "Komárno",
  "Krupina",
  "Kysucké Nové Mesto",
  "Levice",
  "Levoča",
  "Liptovský Mikuláš",
  "Lučenec",
  "Malacky",
  "Martin",
  "Medzilaborce",
  "Michalovce",
  "Myjava",
  "Nové Mesto nad Váhom",
  "Nové Zámky",
  "Námestovo",
  "Partizánske",
  "Pezinok",
  "Piešťany",
  "Poltár",
  "Poprad",
  "Považská Bystrica",
  "Prievidza",
  "Púchov",
  "Revúca",
  "Rimavská Sobota",
  "Rožňava",
  "Ružomberok",
  "Sabinov",
  "Senec",
  "Senica",
  "Skalica",
  "Snina",
  "Sobrance",
  "Spišská Nová Ves",
  "Stará Ľubovňa",
  "Stropkov",
  "Svidník",
  "Topoľčany",
  "Trebišov",
  "Turčianske Teplice",
  "Tvrdošín",
  "Veľký Krtíš",
  "Vranov nad Topľou",
  "Zlaté Moravce",
  "Zvolen",
  "Čadca",
  "Šaľa",
  "Žarnovica",
  "Žiar nad Hronom",
];

export const AcademicDegrees = [
  "Bc.",
  "Ing.",
  "Mgr.",
  "JUDr.",
  "MUDr.",
  "PaedDr.",
  "PhDr.",
  "RNDr.",
  "abs. v. š.",
  "akad.",
  "akad. arch.",
  "akad. mal.",
  "akad. soch.",
  "arch.",
  "Bc. Mgr.",
  "BcA.",
  "dipl.",
  "dipl. tech.",
  "doc.",
  "doc. Dr. Ing.",
  "doc. Dr.",
  "doc. Ing. PhDr.",
  "doc. Ing. arch.",
  "doc. Ing.",
  "doc. JUDr.",
  "doc. MUDr.",
  "doc. MVDr.",
  "doc. Mgr. art.",
  "doc. Mgr.",
  "doc. PaedDr.",
  "doc. PhDr. Ing.",
  "doc. PhDr.",
  "doc. PhMr.",
  "doc. RNDr.",
  "doc. RSDr.",
  "doc. ThDr. PaedDr.",
  "doc. ThDr.",
  "doc. akad. mal.",
  "Dr.",
  "Dr. Ing.",
  "Dr. JUDr.",
  "Dr. MUDr.",
  "Dr. Mgr.",
  "Dr. PhDr.",
  "Dr. PhMr.",
  "Dr. RNDr.",
  "ICDr.",
  "Ing. JUDr.",
  "Ing. MUDr.",
  "Ing. MVDr.",
  "Ing. Mgr.",
  "Ing. PaedDr.",
  "Ing. PhDr.",
  "Ing. RNDr.",
  "Ing. ThDr.",
  "Ing. akad. arch.",
  "Ing. arch. Mgr.",
  "Ing. arch.",
  "JCDr.",
  "JUDr. Ing.",
  "JUDr. MUDr.",
  "JUDr. MVDr.",
  "JUDr. Mgr.",
  "JUDr. PaedDr.",
  "JUDr. PhDr.",
  "JUDr. RNDr.",
  "MBA",
  "MDDr.",
  "MUDr. Ing.",
  "MUDr. MVDr.",
  "MUDr. Mgr.",
  "MUDr. PhDr.",
  "MVDr.",
  "MVDr. Ing.",
  "MVDr. MUDr.",
  "MVDr. PhDr.",
  "Mag. iur.",
  "MgA.",
  "Mgr. Ing.",
  "Mgr. JUDr.",
  "Mgr. PaedDr.",
  "Mgr. PhDr.",
  "Mgr. RSDr.",
  "Mgr. art.",
  "PaedDr. Ing.",
  "PaedDr. JUDr.",
  "PaedDr. MUDr.",
  "PaedDr. Mgr. art.",
  "PaedDr. Mgr.",
  "PaedDr. PhDr.",
  "PhDr. Ing.",
  "PhDr. JUDr.",
  "PhDr. MUDr.",
  "PhDr. Mgr.",
  "PhDr. PaedDr.",
  "PhDr. RNDr.",
  "PhMr.",
  "PhMr. Ing.",
  "PhMr. MVDr.",
  "PhMr. Mgr.",
  "PharmDr.",
  "PharmDr. RNDr.",
  "prof.",
  "prof. Dr.",
  "prof. Dr. Ing.",
  "prof. Ing.",
  "prof. Ing. PhDr.",
  "prof. Ing. RNDr.",
  "prof. JUDr.",
  "prof. MUDr.",
  "prof. MVDr.",
  "prof. MVDr. JUDr.",
  "prof. Mgr.",
  "prof. PaedDr.",
  "prof. PhDr.",
  "prof. RNDr.",
  "prof. RNDr. PhDr.",
  "prof. ThDr.",
  "prof. doc.",
  "prof. doc. Ing.",
  "prof. doc. Mgr.",
  "prom. biol.",
  "prom. chem.",
  "prom. d.",
  "prom. ek.",
  "prom. fil.",
  "prom. filol.",
  "prom. fyz.",
  "prom. geog.",
  "prom. geol.",
  "prom. hist.",
  "prom. knih.",
  "prom. logop.",
  "prom. mat.",
  "prom. nov.",
  "prom. ped.",
  "prom. pharm.",
  "prom. práv.",
  "prom. psych.",
  "prom. vet.",
  "prom. zub.",
  "RCDr.",
  "RNDr. Ing.",
  "RNDr. Mgr.",
  "RNDr. PhDr.",
  "RNDr. PhMr.",
  "RSDr.",
  "RSDr. Ing.",
  "RSDr. Mgr.",
  "ThDr.",
  "ThDr. ThLic.",
  "ThLic.",
  "ThMgr.",
];

export const AcademicDegreesAfter = [
  "ArtD.",
  "BA",
  "BArch",
  "BBA",
  "BBS",
  "BSc",
  "CSc.",
  "DiS.",
  "DiS.art",
  "Dr.h.c.",
  "Dr.theol.",
  "DrSc.",
  "FCCA",
  "LL.M",
  "M.Mus.",
  "M.Phil.",
  "MA",
  "MBA",
  "MPH",
  "MSc",
  "PhD.",
  "PhD. CSc.",
  "PhD. MPH.",
  "Th.D.",
];

export const DistrictOffices = [
  "Banská Bystrica",
  "Bardejov",
  "Bánovce nad Bebravou",
  "Bratislava",
  "Brezno",
  "Čadca",
  "Dolný Kubín",
  "Dunajská Streda",
  "Galanta",
  "Humenné",
  "Kežmarok",
  "Komárno",
  "Košice",
  "Košice - okolie",
  "Levice",
  "Liptovský Mikuláš",
  "Lučenec",
  "Malacky",
  "Martin",
  "Michalovce",
  "Námestovo",
  "Nitra",
  "Nové Mesto nad Váhom",
  "Nové Zámky",
  "Pezinok",
  "Piešťany",
  "Poprad",
  "Považská Bystrica",
  "Prešov",
  "Prievidza",
  "Rimavská Sobota",
  "Rožňava",
  "Ružomberok",
  "Senec",
  "Senica",
  "Spišská Nová Ves",
  "Stará Ľubovňa",
  "Stropkov",
  "Svidník",
  "Šaľa",
  "Štúrovo",
  "Topoľčany",
  "Trebišov",
  "Trenčín",
  "Trnava",
  "Veľký Krtíš",
  "Vranov nad Topľou",
  "Zvolen",
  "Žiar nad Hronom",
  "Žilina",
  "Národná banka Slovenska",
];

export const CommercialRegisterSections = ["Sro", "Pš", "Sa", "Sr", "Firm", "Dr", "Po", "Pšn"];

export const CommercialRegisterDistrictOffices = [
  "Mestský súd Bratislava III",
  "Mestský súd Košice",
  "Okresný súd Banská Bystrica",
  "Okresný súd Nitra",
  "Okresný súd Prešov",
  "Okresný súd Trenčín",
  "Okresný súd Trnava",
  "Okresný súd Žilina",
  "Štatistický úrad Slovenskej republiky",
];

export const BratislavaCityDistricts = [
  "Čunovo",
  "Devín",
  "Devínska Nová Ves",
  "Dúbravka",
  "Jarovce",
  "Karlova Ves",
  "Lamač",
  "Nové Mesto",
  "Petržalka",
  "Podunajské Biskupice",
  "Rača",
  "Rusovce",
  "Ružinov",
  "Staré Mesto",
  "Vajnory",
  "Vrakuňa",
  "Záhorská Bystrica",
];

export const KosiceCityDistricts = [
  "Barca",
  "Dargovských hrdinov",
  "Džungľa",
  "Juh",
  "Kavečany",
  "Košická Nová Ves",
  "Krásna",
  "Lorinčík",
  "Luník IX",
  "Myslava",
  "Nad jazerom",
  "Pereš",
  "Poľov",
  "Sever",
  "Sídlisko KVP",
  "Sídlisko Ťahanovce",
  "Staré Mesto",
  "Šaca",
  "Šebastovce",
  "Ťahanovce",
  "Vyšné Opátske",
  "Západ",
];

// https://www.vlada.gov.sk//statne-sviatky/
export const SlovakHolidays = [
  { d: 1, m: 1 }, // 1. 1.   - Deň vzniku Slovenskej republiky
  { d: 6, m: 1 }, // 6. 1.   - Zjavenie Pána (Traja králi a vianočný sviatok pravoslávnych kresťanov)
  { d: 1, m: 5 }, // 1. 5.   - Sviatok práce
  { d: 8, m: 5 }, // 8. 5.   - Deň víťazstva nad fašizmom
  { d: 5, m: 7 }, // 5. 7.   - Sviatok sv. Cyrila a Metoda
  { d: 29, m: 8 }, // 29. 8.  - Výročie Slovenského národného povstania
  { d: 1, m: 9 }, // 1. 9.   - Deň ústavy SR
  { d: 15, m: 9 }, // 15. 9.  - Sedembolestná Panna Mária
  { d: 1, m: 11 }, // 1. 11.  - Sviatok všetkých svätých
  { d: 17, m: 11 }, // 17. 11. - Deň boja za slobodu a demokraciu
  { d: 24, m: 12 }, // 24. 12. - Štedrý deň
  { d: 25, m: 12 }, // 25. 12. - Prvý sviatok vianočný
  { d: 26, m: 12 }, // 26. 12. - Druhý sviatok vianočný
];

export enum FileUploadAccept {
  IMAGE = "image/*",
  AUDIO = "audio/*",
  VIDEO = "video/*",
  PDF = ".pdf",
  CSV = ".csv",
}

export enum PresetColors {
  DEFAULT = "default",
  PROCESSING = "processing",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  MAGENTA = "magenta",
  RED = "red",
  VOLCANO = "volcano",
  ORANGE = "orange",
  GOLD = "gold",
  LIME = "lime",
  GREEN = "green",
  CYAN = "cyan",
  BLUE = "blue",
  GEEKBLUE = "geekblue",
  PURPLE = "purple",
}

export const AppName: Record<string, AppName> = {
  CLIIP: "cliip",
  PROFIT: "profit",
};

export const BIG_MAX_FILE_SIZE_MB = 200;
export const SMALL_MAX_FILE_SIZE_MB = 10;

export const UUID_PLACEHOLDER = "00000000-0000-0000-0000-000000000000";

export const SMS_TOTP_CODE_RESEND_DELAY_SECONDS = 30;
export const EMAIL_TOTP_CODE_RESEND_DELAY_SECONDS = 60;

export const MOBILE_NUMBER_COUNTRY_WHITELIST: CountryCode[] = [
  CountryTwoLetterCode.SVK,
  CountryTwoLetterCode.CZE,
  CountryTwoLetterCode.AUT,
  CountryTwoLetterCode.HUN,
  CountryTwoLetterCode.ESP,
  CountryTwoLetterCode.CHE,
  CountryTwoLetterCode.ITA,
  CountryTwoLetterCode.CYP,
];

export const SVK_VAT = 23;

export const QueryKeys = {
  RECORD_ID: "recordId",
  DRAFT_ID: "draftId",
  CONTRACT_ID: "contractId",
  CONTRACT_NUMBER: "contractNumber",
  TAB: "tab",
  SIGNER_IDS: "signerIds",
  INSTITUTION_IDS: "institutionIds",
  SIGN_DATE_MIN: "signDateMin",
  SIGN_DATE_MAX: "signDateMax",
  CALC_TYPE: "calcType",
  PREMIUM_TYPE: "premiumType",
} as const satisfies Record<
  string,
  | keyof ContractFilterPageRequest
  | keyof ClientFilterPageRequest
  | "contractNumber"
  | "tab"
  | "recordId"
  | "draftId"
  | "contractId"
  | "calcType"
>;
